import { Props_SnippetParagraph } from './Paragraph.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetParagraph = (props: Props_SnippetParagraph) => {
    const { heading, paragraph } = props

    const classHeadingVisibility: string = heading.visibility?.value ? 'snippet-paragraph__heading--visible' : 'snippet-paragraph__heading--hidden'

    const paragraphAlignmentClass: string = paragraph.alignment?.value ? `snippet-paragraph__content--${paragraph.alignment.value}` : ''
 

    return (
        <section className="snippet-paragraph">
            <div className="snippet-paragraph__container">
                <h2 className={`snippet-paragraph__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
                <div className={`snippet-paragraph__content ${paragraphAlignmentClass}`}>
                    {paragraph.text.value && CompileMarkdown(paragraph?.text?.value)}
                </div>  
            </div>
        </section>
    )
}

export default SnippetParagraph
